import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { CreateLeadService } from 'services/api/create-lead.service';
import { DatanetService } from 'sharedServices/datanet.service';
import { LegalService } from 'services/api/legal.service';
import { PersonService } from 'services/api/person.service';
import { PrefillService } from 'services/api/prefill.service';
import { StaticDataService } from 'services/api/static-data.service';
import { VehicleService } from 'services/api/vehicle.service';
import { RequestQueueModule } from 'sharedGlobals/request-queue/request-queue.module';
import { AppConfigService } from 'sharedServices/app-config.service';
import { TransferStateHttpService } from 'sharedServices/transfer-state-http.service';
import { TransferStateService } from 'sharedServices/transfer-state.service';
import { CmsModule } from 'sharedStores/cms/cms.module';
import { CmsService } from 'sharedStores/cms/cms.service';
import { DropOffModule } from 'sharedStores/drop-off/drop-off.module';
import { ErrorModule } from 'sharedStores/error/error.module';
import { dataLayerSubmitReducer, localStorageSyncReducer } from 'stores/meta-reducers';
import { ResumeQuoteApiService } from 'services/api/resume-quote-api.service';
import { ResolveStoreValueService } from 'sharedServices/resolve-store-value.service';
import { AuthModule } from 'stores/auth/auth.module';
import { ResumeQuoteService } from 'services/resume-quote.service';
import { HomeContentsModule } from 'stores/home-contents/home-contents.module';
import { PaymentDetailsService } from 'services/payment-details.service';
import { TrackbarService } from 'services/api/trackbar.service';
import { HomeContentsService } from 'services/api/home-contents.service';
import { PersonalDetailsService } from 'services/personalDetails.service';
import { QuoteControllerModule } from 'sharedStores/quote-controller/quote-controller.module';
import { QuoteAppInitService } from 'services/quote-app-init.service';
import { RiskAddressNavigationService } from 'services/navigation/riskAddressNavigation.service';
import { PersonalModule } from './personal/personal.module';
import { QuoteModule } from './quote/quote.module';
import { StaticDataModule } from './static-data/static-data.module';
import { VehicleModule } from './vehicle/vehicle.module';
import { ResumeQuoteModule } from './resume-quote/resume-quote.module';
import { DocumentModule } from './document/document.module';
import { PaymentModule } from './payment-details/payment.module';
import { QuoteConfigModule } from './quote-config/quote-config.module';

// Following prevents the data layer from being loaded server side
const isBrowserEnvironment = typeof window !== 'undefined';
let metaReducers: Array<MetaReducer<any, any>>;
if (isBrowserEnvironment) {
    metaReducers = [localStorageSyncReducer, dataLayerSubmitReducer];
} else {
    metaReducers = [localStorageSyncReducer];
}

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        QuoteControllerModule,
        VehicleModule,
        PersonalModule,
        QuoteConfigModule,
        PaymentModule,
        QuoteModule,
        ErrorModule,
        DropOffModule,
        StaticDataModule,
        CmsModule,
        ResumeQuoteModule,
        DocumentModule,
        EffectsModule.forRoot([]),
        StoreModule.forRoot({ router: routerReducer }, { metaReducers: metaReducers }),
        StoreRouterConnectingModule.forRoot(),
        RequestQueueModule,
        AuthModule,
        HomeContentsModule,
    ],
    providers: [
        PrefillService,
        StaticDataService,
        DatanetService,
        VehicleService,
        CreateLeadService,
        TransferStateHttpService,
        TransferStateService,
        AppConfigService,
        QuoteAppInitService,
        CmsService,
        ResumeQuoteService,
        LegalService,
        PersonService,
        ResumeQuoteApiService,
        ResolveStoreValueService,
        HomeContentsService,
        PaymentDetailsService,
        TrackbarService,
        PersonalDetailsService,
        RiskAddressNavigationService,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class BaseStoreModule {}
